<template>
    <div class="signDialog" v-loading="loading">
        <el-row class="receiveRight">
            <el-col :span="8">
                <div class="colItem">
                    <span class="label">预约单号：</span>
                    <span class="value">{{ suNingData.vendorRefNo }}</span>
                </div>
            </el-col>
            <el-col :span="16">
                <div class="colItem">
                    <span class="label">客户订单号：</span>
                    <span class="value">{{ suNingData.custmerOrderNo }}</span>
                </div>
            </el-col>
        </el-row>

        <el-table
            :data="suNingData.detailResDtos || []"
            border
            tooltip-effect="dark"
            height="260"
        >
            <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :show-overflow-tooltip="true"
                :prop="item.prop"
                :label="item.label"
                align="center"
            ></el-table-column>
        </el-table>
    </div>
</template>

<script>
import { getSuNingDataApi } from '@/modules/transport/otp/api/performanceReceiptSign.js';

export default {
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            suNingData: {
                vendorRefNo: '',
                custmerOrderNo: '',
                detailResDtos: []

            },
            columns: [
                { prop: 'itemCode', label: '商品编码' },
                { prop: 'itemName', label: '商品名称' },
                { prop: 'itemQty', label: '商品数量' },
                { prop: 'rcptQty', label: '苏宁签收正品数量' },
                { prop: 'receiverRealReceiveCount', label: '用户签收正品' },
                { prop: 'receiverRejectQty', label: '用户签收拒收' }
            ]
        };
    },
    methods: {
        /**
         * @description 获取苏宁订单下的入库详情
         * @param {String} taskNo 运输单号
         */
        getDataList () {
            this.loading = true;
            getSuNingDataApi(this.rowData.taskNo).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.suNingData = res.data;
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted () {
        this.getDataList();
    }
};
</script>

<style lang="less">
@import './signInDialog.less';
</style>
